exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".account_box[data-v-51671c88]{padding:20px 20px 40px 20px}.title[data-v-51671c88]{font-size:20px;font-weight:600}.search_criteria[data-v-51671c88]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-top:10px}.search_criteria>div[data-v-51671c88]{margin:0 5px;width:180px}.page_box[data-v-51671c88]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.page_box[data-v-51671c88]  .el-pagination__jump{margin-left:0px}", ""]);

// exports
